// extracted by mini-css-extract-plugin
export default {"icon":"ReadOnly_icon__N2Lsa","text":"ReadOnly_text__1xQbX"};